import React, { useEffect } from "react";
import Modal from "react-bootstrap/Modal";

export default function FormDialog({ title, onClose, onSubmit, children, footer, wide = false }) {
  useEffect(() => {
    const previous = document.activeElement;
    return () => {
      if (previous && previous.focus) previous.focus();
    };
  }, []);

  return (
    <Modal
      show
      centered
      scrollable
      onHide={onClose}
      size={wide ? "xl" : "lg"}
    >
      <form onSubmit={onSubmit} noValidate>
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="accounts-dialog-body">{children}</Modal.Body>
        {footer ? <Modal.Footer className="accounts-dialog-footer">{footer}</Modal.Footer> : null}
      </form>
    </Modal>
  );
}
